/**
 * RegistrationReminderLines.tsx - the reminder loop of one registration in words: «Erinnert am … · Frist
 * 2 bis …» once the insurer was reminded (or «Erinnerung nicht versendet» with the reason), and
 * «Klärung seit … · Aufgabe» with a link to the escalation task. Dates are the Swiss calendar day.
 */

import { formatZurichDateDe, REGISTRATION_REMINDER_ERROR_LABEL } from '@brokly/shared';
import type { RegistrationDto } from '@brokly/shared';

type ReminderFields = Pick<RegistrationDto, 'status' | 'reminded_at' | 'frist_2_due_at' | 'escalation_task_id' | 'status_changed_at' | 'reminder_error_code'>;

const day = (iso: string | null): string | null => (iso ? formatZurichDateDe(iso) : null);

export function RegistrationReminderLines({ row }: { row: ReminderFields }) {
  const reminded = day(row.reminded_at);
  const frist2 = day(row.frist_2_due_at);
  const since = row.status === 'klaerung' ? day(row.status_changed_at) : null;
  if (!reminded && !since) return null;
  return (
    <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
      {reminded && (
        <span data-testid="reg-reminder">
          {`Erinnert am ${reminded}${frist2 ? ` · Frist 2 bis ${frist2}` : ''}`}
          {row.reminder_error_code && (
            <span className="ml-2 text-sem-decide">{REGISTRATION_REMINDER_ERROR_LABEL[row.reminder_error_code] ?? row.reminder_error_code}</span>
          )}
        </span>
      )}
      {since && (
        <span data-testid="reg-klaerung">
          {`Klärung seit ${since}`}
          {row.escalation_task_id && (
            <>
              {' · '}
              <a className="underline" href={`/aufgaben?task=${row.escalation_task_id}`}>
                Aufgabe
              </a>
            </>
          )}
        </span>
      )}
    </div>
  );
}
